import { useContext } from 'react';
// Import types and context from shared definition file (NO Firebase imports)
import { UserContext, type UserContextType, type AppUser } from './userContextDefinition';

// This file contains ONLY the useUser hook
// NO Firebase imports to prevent eager loading

// Guest user state for public routes (no Firebase loaded)
export const guestUserState: UserContextType = {
  user: null,
  loading: false,
  setUser: () => {},
  setLoading: () => {},
  setNotifications: () => {},
  login: () => {},
  logout: () => {},
  badges: [],
  addBadge: () => {},
  activities: [],
  addActivity: () => {},
  notifications: [],
  addNotification: () => {},
  markAllNotificationsRead: () => {},
  deleteAllNotifications: () => {},
  updatePhoto: () => {},
  startNotificationsListener: () => {},
  stopNotificationsListener: () => {},
  pushSubscription: null,
  notificationsEnabled: false,
  setNotificationsEnabled: () => {},
  enableNotifications: async () => {},
  disableNotifications: async () => {},
  updateFlavorProfile: () => {},
  showBadgeDialog: () => {},
};

/**
 * Hook to access user context
 * Returns guest state if used outside UserProvider (public routes)
 * This prevents Firebase from loading on public pages
 */
export function useUser(): UserContextType {
  const context = useContext(UserContext);
  // Return guest state if used outside UserProvider
  if (!context) {
    return guestUserState;
  }
  return context;
}

// Re-export types for convenience
export type { AppUser, UserContextType };
